var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.64,
    height: 5.7
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85.11L.36 2.2a.74.74 0 000 1.27l3.51 2.12A.74.74 0 005 5V4h3.9a.74.74 0 00.74-.74v-.87a.74.74 0 00-.74-.74H5V.74A.74.74 0 003.85.11z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjY0IiBoZWlnaHQ9IjUuNyIgdmlld0JveD0iMCAwIDkuNjQgNS43Ij4KICA8cGF0aCBkPSJNMy44NS4xMS4zNiwyLjJhLjc0Ljc0LDAsMCwwLDAsMS4yN0wzLjg3LDUuNTlBLjc0Ljc0LDAsMCwwLDUsNVY0SDguOWEuNzQuNzQsMCwwLDAsLjc0LS43NFYyLjM5YS43NC43NCwwLDAsMC0uNzQtLjc0SDVWLjc0QS43NC43NCwwLDAsMCwzLjg1LjExWiIvPgo8L3N2Zz4K";
export { SvgSmallArrowLeft as ReactComponent };